export default "/img/MT.68d926ffd5e7dd638e92f322bccfd450.png";